import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "submitButton"]

  connect() {
    this.update()
  }

  update() {
    this.submitButtonTarget.disabled = !this.checkboxTarget.checked
  }
}
